import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
  ToastProps,
} from "@chakra-ui/react"
import { chakra } from "@chakra-ui/system"
import { MdCheckCircle, MdInfo, MdWarning } from "react-icons/md"

const Toast = (props: ToastProps) => {
  const {
    status = "info",
    variant = "solid",
    id,
    title,
    isClosable,
    onClose,
    description,
    colorScheme,
    icon,
  } = props

  const ids = id
    ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`,
      }
    : undefined

  const STATUSES = {
    info: { icon: MdInfo, colorScheme: "blue" },
    warning: { icon: MdWarning, colorScheme: "orange" },
    success: { icon: MdCheckCircle, colorScheme: "green" },
    error: { icon: MdWarning, colorScheme: "red" },
    loading: { icon: MdInfo, colorScheme: "yellow" },
  }

  const color = STATUSES[status].colorScheme || colorScheme || "blue"

  return (
    <Alert
      addRole={false}
      status={status}
      variant={variant}
      id={ids?.root}
      alignItems={"start"}
      borderRadius={"md"}
      boxShadow={"lg"}
      paddingEnd={8}
      textAlign={"start"}
      width={"auto"}
      colorScheme={color}
    >
      <AlertIcon>{icon}</AlertIcon>
      <chakra.div
        flex={"1"}
        maxWidth={"100%"}
      >
        {title && <AlertTitle id={ids?.title}>{title}</AlertTitle>}
        {description && (
          <AlertDescription
            id={ids?.description}
            display={"block"}
          >
            {description}
          </AlertDescription>
        )}
      </chakra.div>
      {isClosable && (
        <CloseButton
          size={"sm"}
          onClick={onClose}
          position={"absolute"}
          insetEnd={1}
          top={1}
        />
      )}
    </Alert>
  )
}

export default Toast
